<template>
    <form action="">
        <div class="modal-card" style="width: auto">
            <header class="modal-card-head">
                <p class="modal-card-title">Login to iRebal</p>
                <button
                    type="button"
                    class="delete"
                    @click="$emit('close')"/>


            </header>
            <section class="modal-card-body">
                <div style="text-align: center;">
                    <img :src="`${$root.$data.STATIC_ROOT}sillyimages/td_veo.png`" style="width: 80px; margin-bottom: 1rem;">
                </div>
                <b-field label="User ID">
                    <b-input
                        type="text"
                        :value="user_id"
                        v-model="user_id"
                        placeholder="Your iRebal user id"
                        required
                        icon-pack="fa"
                        icon-right="lock"
                        >
                    </b-input>
                </b-field>

                <b-field label="Password">
                    <b-input
                        type="password"
                        :value="password"
                        v-model="password"
                        placeholder="Your iRebal password"
                        icon-pack="fa"
                        icon-right="lock"
                        required>
                    </b-input>
                </b-field>
                
                <p class="is-size-6 has-text-success has-text-weight-bold">
                  Secure SSL Connection
                  <span class="icon">
                  <i class="fas fa-lock"></i>
                  </span>
                </p>
                <p class="is-size-7 has-text-weight-bold">
                  Your credentials are never saved
                </p>

            </section>
            <footer class="modal-card-foot">
                <b-button
                    label="Close"
                    @click="$emit('close')" />
                <b-button
                    label="Login"
                    type="is-primary" 
                    @click="authenticate" 
                    />
            
            </footer>
            
        </div>
    </form>
</template>

<script>
  export default {
    data() {
      return {
        user_id: '',
        password: '',
        error: '',
      }
    },
    props: {
        success: Function,
        fail: Function,
    },
    methods: {
      authenticate: async function() {
        let self = this;
        const resp = await fetch(
            `/api/v1/integrations/irebal/auth/`,
            {
              method: 'POST',
              headers: {
                'X-CSRFToken': this.$root.$data.csrfToken,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                user_id: this.user_id,
                password: this.password,
              })
            },
        )
        .then((response) => {
          if(!response.ok) {
          self.error = 'Seems there was an issue with the credentials. Please try again!'
          this.$buefy.toast.open({
              duration: 5000,
              message: self.error,
              position: 'is-top',
              type: 'is-danger'
          })
          throw new Error('Auth failed');
        }
          return response.json()
        })
        .then((responseData) => {
          let data = responseData
          self.expiry = data.expiry;
          this.success(true);
          self.$parent.close();
          return true;
        }).catch((error) => {return this.fail(true);});

        return resp;

      },
    }
  }
</script>

<style>
</style>